
export const interactiveData = {
  polls: {
    details: {
      title: "Poll Details",
      period: "Period",
      status: "Status",
      active: "Active",
      closed: "Closed",
      exportVoters: "Export Voters",
      closePoll: "Close Poll",
      successClosed: "Poll successfully closed!",
      errorClosing: "Error occurred while closing the poll",
      results: "Results",
      voters: "Voters",
      tableHeaders: {
        option: "Option",
        votes: "Number of Votes",
        percentage: "Percentage",
        name: "Name",
        email: "Email",
        date: "Date",
        answer: "Answer"
      },
      chart: {
        votes: "Votes",
        option: "Option"
      }
    }
  },
  title: "Interactive Data",
  participants: "Participants",
  date: "Date",
  status: "Status",
  active: "Active",
  closed: "Closed",
  votes: "Votes",
  subscribers: "Subscribers",
  discount: "Discount",
  clicks: "Clicks"
};
